// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';

export const ArrowLeft = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 48 48'
      width={size}
      height={size}
      fill={fill || 'none'}
      stroke={stroke}
      strokeWidth='4px'
    >
      <polygon
        xmlns='http://www.w3.org/2000/svg'
        points='34.6 46.4 12.3 24 34.6 1.6 35.4 2.4 13.7 24 35.4 45.6 34.6 46.4'
      />
    </svg>
  );
};
